const searchMapEvents: StandardObjectInterface = {
    opened: 'search-map-opened',
    closed: 'search-map-closed'
};

export default searchMapEvents;
